import React from 'react'
import Skeleton from 'react-loading-skeleton'

const CountMetricCard = ({ svgsrc, metricValue, metricDescription, loading, loaderHeight, classes = '', valueClasses = 'text-3xl', desClasses = '', allow_bug_dwnld = false, bugReport }) => {
  if (loading) {
    return (
      <div className={classes.replace('flex', '')}>
        <Skeleton width='100%' height={loaderHeight} />
      </div>
    )
  }

  return (
    <div className={'p-8 bg-white border border-gray-200 rounded-md text-center ' + classes}>
      <dt className='flex flex-row items-center justify-center'>
        <img className='inline-block h-5 w-5' src={svgsrc} alt='metric card avatar' />
        <span className={'font-semibold ml-3 leading-none ' + valueClasses}>{metricValue || 0}</span>
      </dt>

      <p className={'mb-0 text-gray-500 ' + desClasses}>{metricDescription}</p>
      { allow_bug_dwnld &&
        <div className='flex flex-row items-center justify-center'>
          <button
          type='submit'
          onClick={bugReport}
          className='rounded-md leading-4 border-none py-2 bg-blue-600 text-sm font-semibold text-white focus:outline-none px-4 mt-3 block'
        >
        Download bug report
      </button>
        </div>}
    </div>
  )
}

export default CountMetricCard
